import React from 'react';
import { ReportSection, ReportSubsection } from '../framework';

export const RecommendationSection: React.FC = () => {
  return (
    <ReportSection id="recommendation" title="Recommendation" subtitle="What the data suggests">
      <p className="text-gray-700 mb-6">
        In most scenarios we modeled, selling and investing produces similar or better outcomes than keeping
        and renting. The post-Prop-19 property tax increase makes rental cash flows tighter than they would have
        been historically. Renting wins primarily if Newport Beach significantly outperforms stock markets.
      </p>

      <ReportSubsection title="The Co-Ownership Factor">
        <p className="text-gray-700 mb-4">
          This property will be owned 50/50 by two people. This works fine when everyone agrees,
          but introduces complications:
        </p>

        <ul className="list-disc list-inside text-gray-600 space-y-1 mb-4 text-sm">
          <li>What if one owner wants to sell in five years and the other doesn't?</li>
          <li>If the property needs a $30,000 roof, both owners need $15,000. What if one can't?</li>
          <li>Who decides rent price, tenant selection, or when to make major repairs?</li>
          <li>What happens to each owner's share when they pass away?</li>
        </ul>

        <p className="text-gray-700">
          Selling and splitting proceeds is clean. Keeping the property means running a business together.
        </p>
      </ReportSubsection>

      <ReportSubsection title="The Tax Flexibility Factor">
        <p className="text-gray-700">
          Selling now means ~$0 in capital gains tax. But even if you sell later, you only pay tax on appreciation
          <em>after</em> the inheritance—not on the historical gains. The real advantage of selling now is flexibility:
          with stocks you can sell portions over time, harvest losses, and optimize taxes year by year. With one
          house, you eventually realize all gains in a single tax year.
        </p>
      </ReportSubsection>
    </ReportSection>
  );
};
